import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
export default function ContactBar() {
  return (
    <>
      <Row className="no-gutters mt-5 mb-sm-5">
        <Container>
          <Row>
            <Col sm={{ offset: 2, span: 8 }} className="text-center">
             <h4>If you have any queries, please contact.</h4>
  <p className="mt-2 mb-4 text-muted">
    Our team is ready to assist you with information, support, or custom solutions.
  </p>
              <Link
                className="btn-sm knowMoreBtn text-white text-decoration-none"
                to="/Contact"
              >
                Contact us
              </Link>
            </Col>
          </Row>
        </Container>
      </Row>
    </>
  );
}
